<template>
    <v-dialog
      fullscreen
      eager
      v-model="dialog"
      hide-overlay
      content-class="form-dialog"
    >
    <v-card>
      <v-card-title>
        <v-col class="text-right px-4">
          <v-btn icon @click="dialog=false">
            <v-icon large color="primary">close</v-icon>
          </v-btn>
        </v-col>
      </v-card-title>

      <v-card-text>
        <v-textarea
          outlined
          readonly
          v-model="data"
          auto-grow
        />

      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="dialog = false"
        >
          {{ $t('buttons:close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import LogsService from '@/modules/display/services/logs-service';
import Utils from '@/modules/core/services/utils';

export default {
  name: "ShowLogFile",
  data() {
    return {
      currentId: null,
      dialog: false,
      data: ''
    }
  },
  methods: {
    initialization(item) {
      this.currentId = item.id;

      LogsService.readFileLog(
        item.id,
        (response) => {
          this.data = response.data;
          this.dialog = true;
        },
        () => {
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('display/logs:log-file.file')}));
        }
      );
    }
  }
}
</script>